import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from './index';
import MoreIcon from '../Icons/MoreIcon';

const OptionDropdown = ({ children, ...others }) => (
  <Dropdown
    toggleComponent={<MoreIcon />}
    {...others}
    className="dropdown dropdown--small  dropdown--option"
  >
    {children}
  </Dropdown>
);

OptionDropdown.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

OptionDropdown.defaultProps = {
  children: null,
};

OptionDropdown.Item = Dropdown.Item;

export default OptionDropdown;
